/* eslint-disable react/jsx-props-no-spreading */
// DESIGN_SYSTEM_GENERATED_ICONS
import React from 'react';
import Icon from './icons';
function AlertInfoFilled(props) {
    return (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.9912 7C11.5765 7 11.25 7.32647 11.25 7.75C11.25 8.17353 11.5765 8.5 11.9912 8.5C12.4235 8.5 12.75 8.17353 12.75 7.75C12.75 7.32647 12.4147 7 11.9912 7ZM11.25 15.7431C11.25 16.1569 11.59 16.5 12 16.5C12.42 16.5 12.75 16.167 12.75 15.7431V11.7569C12.75 11.3431 12.41 11 12 11C11.59 11 11.25 11.3431 11.25 11.7569V15.7431Z", fill: "#001325", fillOpacity: "0.92" })));
}
export default AlertInfoFilled;
